import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Table from './Table.jsx'
import _ from 'lodash'

class SwapsComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (_.size(this.props.swap) > 0) {
      return <div><Table swap={this.props.swap}></Table></div>
    }
    return <div>Loading</div>
  }
}

SwapsComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  swap: PropTypes.object.isRequired,
}

export default SwapsComponent
